import { TileTypes } from './TileTypes';
export class SpawnTypes extends TileTypes {
    constructor() {
        super();
    }
}
SpawnTypes.CHEST = 'chest';
SpawnTypes.MOB = 'mob';
SpawnTypes['__class'] = 'de.coco.mindLinq.world.SpawenTypes';
